
import React, { FC } from 'react';

type PropsT = {
  fill?: string;
};

const CopySquareIcon24: FC<PropsT> = ({ fill = 'currentColor' }) => (
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M8 8V4C8 2.9 8.9 2 10 2H20C20.5304 2 21.0391 2.21071 21.4142 2.58579C21.7893 2.96086 22 3.46957 22 4V14C22 14.5304 21.7893 15.0391 21.4142 15.4142C21.0391 15.7893 20.5304 16 20 16H16V20C16 20.5304 15.7893 21.0391 15.4142 21.4142C15.0391 21.7893 14.5304 22 14 22H4C3.46957 22 2.96086 21.7893 2.58579 21.4142C2.21071 21.0391 2 20.5304 2 20V10C2 8.9 2.9 8 4 8H8ZM10 8H14C14.5304 8 15.0391 8.21071 15.4142 8.58579C15.7893 8.96086 16 9.46957 16 10V14H20V4H10V8ZM4 10V20H14V10H4Z" fill={fill}/>
</svg>
);

export default CopySquareIcon24;





import React, { FC } from 'react';

type PropsT = {
  fill?: string;
};

const CopySquareIcon24: FC<PropsT> = ({ fill = 'currentColor' }) => (
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M8 8V4C8 2.9 8.9 2 10 2H20C20.5304 2 21.0391 2.21071 21.4142 2.58579C21.7893 2.96086 22 3.46957 22 4V14C22 14.5304 21.7893 15.0391 21.4142 15.4142C21.0391 15.7893 20.5304 16 20 16H16V20C16 20.5304 15.7893 21.0391 15.4142 21.4142C15.0391 21.7893 14.5304 22 14 22H4C3.46957 22 2.96086 21.7893 2.58579 21.4142C2.21071 21.0391 2 20.5304 2 20V10C2 8.9 2.9 8 4 8H8ZM10 8H14C14.5304 8 15.0391 8.21071 15.4142 8.58579C15.7893 8.96086 16 9.46957 16 10V14H20V4H10V8ZM4 10V20H14V10H4Z" fill={fill}/>
</svg>
);

export default CopySquareIcon24;




